import { render } from "./FormQuestionario.vue?vue&type=template&id=f125b566&scoped=true"
import script from "./FormQuestionario.vue?vue&type=script&lang=js"
export * from "./FormQuestionario.vue?vue&type=script&lang=js"

import "./FormQuestionario.vue?vue&type=style&index=0&id=f125b566&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f125b566"]])

export default __exports__